import React from 'react';
import useAppRouter from "../../hooks/useAppRouter";

export const ForbiddenPage: React.FC = () => {
  const { gotoTopByUser } = useAppRouter();

  return (
    <div className="min-h-full bg-primary flex flex-col justify-center items-center p-16">
      <div className="text-8xl text-white font-bold">403</div>
      <div className="text-5xl text-white font-bold">Forbidden</div>
      <div className="text-white font-semibold mt-6">このページにアクセスする権限がありません。</div>
      <div className="flex justify-center">
        <button
          type="button"
          className="absolute bottom-0 text-white font-semibold focus:text-topacity-50 mb-8"
          onClick={() => gotoTopByUser()}
        >
          TOPページへ戻る &gt;
        </button>
      </div>
    </div>
  );
};
